import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Projectgoalsanimal() {
  return (
    <section className="project-goals-animal p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="">
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#007F6E" }}>Project</span> Goals
            </h2>
            <p>
              The primary goal was to create a ridiculously funny game that
              would capture the attention of a broad audience, from teenagers to
              individuals in their mid-30s. The game had to be puzzling, highly
              engaging, and absurd, tapping into the power of humor and
              "stupidity" as a core element of creativity.
            </p>
            <h3 style={{ color: "#000" }}>Key Features & Goals</h3>
            <ul>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                Funny and absurd gameplay that encourages curiosity.
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                Puzzle-based mechanics that challenge the player while keeping
                them entertained
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="42"
                  fill="none"
                  viewBox="0 0 41 42"
                >
                  <path
                    fill="#00806F"
                    d="M18.165 25.818c-.3-.023-.58-.163-.78-.39l-4.679-4.679a1.17 1.17 0 0 1 1.56-1.56l3.852 3.853 13.304-13.21a1.17 1.17 0 0 1 1.56 1.56L18.945 25.428a1.15 1.15 0 0 1-.78.39"
                  ></path>
                  <path
                    fill="#00806F"
                    d="M20.504 34.788A14.04 14.04 0 0 1 8.23 27.52 13.6 13.6 0 0 1 6.561 22.2a14.04 14.04 0 0 1 7.175-13.74 13.6 13.6 0 0 1 5.318-1.669 13.9 13.9 0 0 1 5.537.53 1.17 1.17 0 1 1-.671 2.23 11.9 11.9 0 0 0-4.679-.436c-1.555.158-3.062.63-4.43 1.388a11.7 11.7 0 0 0-3.43 2.87 11.57 11.57 0 0 0-2.558 8.593 11.5 11.5 0 0 0 1.388 4.43 11.7 11.7 0 0 0 2.87 3.43 11.57 11.57 0 0 0 8.593 2.559 11.5 11.5 0 0 0 4.43-1.388 11.7 11.7 0 0 0 3.43-2.87 11.57 11.57 0 0 0 2.559-8.594 1.23 1.23 0 0 1 2.448-.234 14.04 14.04 0 0 1-7.19 13.74 13.6 13.6 0 0 1-5.396 1.748z"
                  ></path>
                </svg>
                Designed to attract content creators like YouTubers, and Twitch
                Streamers who thrive on humor and unpredictability.
              </li>
            </ul>

            <Link
              to="/contact"
              className="border_btn animal-case-btn"
              aria-label="TekRevol Contact"
            >
              The Clock’s Ticking! Let’s Turn Your Crazy Idea into Reality!
            </Link>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="text-center">
            <StaticImage
              src="../../../images/case-studies/animal-debt/Project-Goals-1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={589}
              height={754}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectgoalsanimal;
